import { Injectable } from '@angular/core';
import { LogService} from 'app/_services/logmanager.service';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { GlobalsService } from 'app/_services/globals.service';

@Injectable()
export class NeedSecretariaGuard implements CanActivate {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private globalStorage: GlobalsService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        LogService.log('NeedSecretariaGuard' , 'canActivate');

        const secretaria = this.globalStorage.getItem('secretaria');
        if (!secretaria) {
            LogService.log('NeedSecretariaGuard' , 'No secretaria. Redirecting to welcome');

            const url = state.url.split('?');

            this.globalStorage.setItems([
                {name: 'returnUrl', value: url[0]},
                {name: 'navigationExtras', value: JSON.stringify(route.queryParams)}
            ]).then(() => {
                this.router.navigate(['/welcome']);
            });
        }
        return secretaria !== '';
    }
}
